import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from 'projects/environments/environment';
import { initSentry } from 'projects/lib-shared-core/src/lib/sentry/sentry-init';
import { initRum } from 'projects/lib-shared-core/src/lib/rum/rum-init';

if (environment.production) {
  enableProdMode();
}

initSentry(environment, 'myworkspace');
initRum(environment, 'myworkspace');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
